import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-2 group-[.toaster]:border-foreground group-[.toaster]:shadow-[4px_4px_0_0_#000] dark:group-[.toaster]:shadow-[4px_4px_0_0_#fff] group-[.toaster]:rounded-none group-[.toaster]:font-bold group-[.toaster]:uppercase group-[.toaster]:tracking-tight",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-[10px] group-[.toast]:font-mono",
          actionButton: "group-[.toast]:bg-foreground group-[.toast]:text-background group-[.toast]:rounded-none group-[.toast]:border-2 group-[.toast]:border-background group-[.toast]:font-black group-[.toast]:uppercase",
          cancelButton: "group-[.toast]:bg-background group-[.toast]:text-foreground group-[.toast]:rounded-none group-[.toast]:border-2 group-[.toast]:border-foreground group-[.toast]:font-black group-[.toast]:uppercase",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
